// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import {
  call,
  put,
  select,
  takeEvery
} from 'redux-saga/effects';
import * as types from './actionTypes';

import * as voucherConfirmedActions from './actions';
import {
  redeemVoucher,
} from './service';
import * as voucherConfirmedSelectors from './selectors.js';

import history from '../../../services/history';
import { cleanAmount, redeemAmountError } from '../../../services/voucherAmount';


function* redeemVoucherSaga() {
  const statusValue = yield select(voucherConfirmedSelectors.getValueStatus);

  let valid = statusValue.status;
  let message = '';

  const bookshopCustomer = yield select(voucherConfirmedSelectors.getBookshopCustomer);
  // Trimmed: a pasted or scanned figure brings spaces with it, and " 0.5 "
  // is a perfectly good half-pound.
  const value = cleanAmount(yield select(voucherConfirmedSelectors.getValue));

  // This voucher's own balance, not the customer's pooled Balance. Vouchers
  // now carry their own balance and are redeemed one at a time, so a customer
  // holding two vouchers must not be able to overspend one of them.
  const voucher = bookshopCustomer.Voucher || {};

  // Same rules as the Redeem voucher screen, from one shared module. The old
  // pattern here demanded exactly two decimals, so "0.5" was rejected as an
  // incorrect value while the other screen accepted it.
  const error = redeemAmountError(value, voucher.Balance);

  if (error) {
    valid = false;
    message = error;
  }

  if (valid) {
    yield put(voucherConfirmedActions.startLoading());
    yield put(voucherConfirmedActions.closeConfirmModal());

    const CustomerId = localStorage.getItem('loggedID');
    const Token = localStorage.getItem('token');

    // RedeemVoucher takes the voucher Code and Amount. The old
    // BookshopCustomerId/RedeemValue pair addressed the retired pooled
    // balance, so the request was rejected and the redemption silently did
    // nothing - which is what the client saw.
    const data = {
      CustomerId,
      Token,
      Code: voucher.Code,
      Amount: value,
    };

    const response = yield call(redeemVoucher, data);

    if (response.ok) {
      yield put(voucherConfirmedActions.redeemVoucherSuccess(response.body));
      yield put(voucherConfirmedActions.resetForm());

      history.push(
        `/account/vouchers/customer-overview/${bookshopCustomer.Id}`,
        { bookshopCustomerId: bookshopCustomer.Id }
      );
    } else {
      yield put(voucherConfirmedActions.closeConfirmModal());
      yield put(voucherConfirmedActions.validateRedeemValue({
        status: false,
        message: response.body.Reason,
      }));
    }

    yield put(voucherConfirmedActions.stopLoading());

  } else {

    yield put(voucherConfirmedActions.closeConfirmModal());
    yield put(voucherConfirmedActions.validateRedeemValue({
      status: valid,
      message,
    }));
  }
}

const voucherConfirmedSagas = [
  takeEvery(types.VOUCHER_CONFIRMED_REDEEM_VOUCHER, redeemVoucherSaga),
];

export default voucherConfirmedSagas;
